export const PUBLIC_MOUNT_ID = '00000000-0000-0000-0000-000000000001';
export const USER_STORAGE_MOUNT_ID = '00000000-0000-0000-0000-000000000002';
export const ONEDRIVE_MOUNT_ID = '00000000-0000-0000-0000-000000000003';

/** True when the mount is the shared virtual Public folder (no discussions). */
export function isPublicStorageMount(mountId: string | null | undefined): boolean {
  return (mountId ?? '').trim().toLowerCase() === PUBLIC_MOUNT_ID;
}

export function isFileReviewDisabledStorageMount(mountId: string | null | undefined): boolean {
  const normalized = (mountId ?? '').trim().toLowerCase();
  return (
    normalized === PUBLIC_MOUNT_ID ||
    normalized === USER_STORAGE_MOUNT_ID ||
    normalized === ONEDRIVE_MOUNT_ID
  );
}

/** True when the mount is private per-user My Storage (owner-only; no presence/discussions). */
export function isUserStorageMount(mountId: string | null | undefined): boolean {
  return (mountId ?? '').trim().toLowerCase() === USER_STORAGE_MOUNT_ID;
}

export function formatAuditDateTime(value: string | null | undefined): string {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
}

export function formatMountLabel(mountId: string): string {
  if (isPublicStorageMount(mountId)) return 'Public';
  return mountId.trim().toLowerCase() === USER_STORAGE_MOUNT_ID ? 'My Storage' : mountId;
}

export function formatOperationLabel(operation: string): string {
  switch (operation) {
    case 'createDirectory':
      return 'Create folder';
    case 'upload':
      return 'Upload';
    case 'download':
      return 'Download';
    case 'delete':
      return 'Delete';
    case 'rename':
      return 'Rename';
    case 'pdfComment':
      return 'PDF comment';
    case 'pdfHighlight':
      return 'PDF highlight';
    case 'pdfCommentEdit':
      return 'PDF comment edit';
    case 'pdfCommentDelete':
      return 'PDF comment delete';
    default:
      return operation;
  }
}
